import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'new-site-add',
  templateUrl: './new-site-add.component.html',
  styleUrls: ['./new-site-add.component.scss']
})
export class NewSiteAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
